import type { HelpFile } from '../../types/help'
import { ReviewStepTestIds } from '../../../testids/ReviewStepTestIds'

export const reviewStepHelp: HelpFile = {
  docPage: '/docs/onboarding/review',
  texts: {
    [ReviewStepTestIds.cardTitleReviewAttributes]:
      'Custom attributes captured during onboarding — review for accuracy before submitting.',
    [ReviewStepTestIds.cardTitleReviewIdentity]:
      'Identity record being created — login, type, and lifecycle settings.',
    [ReviewStepTestIds.cardTitleReviewOrganization]:
      'Organization being onboarded together with this identity, if any.',
    [ReviewStepTestIds.cardTitleReviewPerson]:
      'Person details — name, contact information, and personal attributes.',
    [ReviewStepTestIds.reviewDisplayName]:
      'Display name shown for this entity throughout the system.',
    [ReviewStepTestIds.reviewEditIdentity]:
      'Return to the identity step to correct captured data.',
    [ReviewStepTestIds.reviewEditOrganization]:
      'Return to the organization step to correct captured data.',
    [ReviewStepTestIds.reviewEditPerson]:
      'Return to the person step to correct captured data.',
    [ReviewStepTestIds.reviewSectionIdentity]:
      'Identity-level data captured during the wizard.',
    [ReviewStepTestIds.reviewSectionOrganization]:
      'Organization-level data captured during the wizard.',
  },
}
